"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
function Switch(props) {
    var label = props.label, _a = props.labelPlacement, labelPlacement = _a === void 0 ? 'end' : _a, rest = tslib_1.__rest(props, ["label", "labelPlacement"]);
    return (react_1["default"].createElement(core_1.FormControlLabel, { control: react_1["default"].createElement(core_1.Switch, tslib_1.__assign({}, rest)), label: label, labelPlacement: labelPlacement }));
}
exports["default"] = Switch;
//# sourceMappingURL=Switch.js.map